export const isExperimentEnabled = (experiments, spec)=>experiments?.[spec] === true || experiments?.[spec] === 'true' || experiments?.[spec] === 'B';

//# sourceMappingURL=is-experiment-enabled.js.map